const rootAppKey = "isRootApp";
export const getRootAppWindow = (currentWindow) => {
    const isRoot = currentWindow[rootAppKey];
    if (isRoot) {
        return currentWindow;
    }
    return getRootAppWindow(currentWindow.parent);
};
